/* eslint-disable no-param-reassign */
/* eslint-disable default-case */
import { getPrimaryTopic } from './signup/primaryTopic';

// Conventional slug conversion of the site name in Lytics:
const siteNameSlug = window.siteName
  .toLowerCase()
  .replace(/[. ]/g, '_')
  .replace(/-/g, '');

/**
 * @returns {NodeListOf<Element>} Non-Advertise Sign up buttons
 */
const getSignupButtons = () => {
  return document.querySelectorAll('.nav-signup-button:not(.advertise-button)');
};

/**
 * Modifies the url target of the "Sign up" buttons to include signup_path param.
 * On TechTarget, adds the page's community as signup_community param, which
 * signup page 1 reads in the browser.
 * @see ENGB-558
 */
const appendSignUpPath = () => {
  // Assigned dynamically to still be able to cache the nav
  // ex ref cache 21600 desktop_nav in /templates/desktop_nav.html:5`
  const primaryTopic = getPrimaryTopic(window.dataLayer);
  const signupCommunityParam = primaryTopic ? `&signup_community=${encodeURIComponent(primaryTopic)}` : '';
  getSignupButtons().forEach((el) => {
    el.href = `${el.getAttribute('href')}&signup_path=${window.location.pathname}${signupCommunityParam}`;
  });
};

/**
 * @returns {Array} An array of Lytics audience slugs that would indicate that a user
 * is a potential marketer of the current site.
 */
const getMarketerAudienceSlugs = () => {
  const audienceSlugs = [];

  // Conventionally constructed audience slugs to include:
  audienceSlugs.push(`${siteNameSlug}_marketers`);

  // Additionally included audience slugs that don't follow convention:
  switch (window.siteName) {
    case 'Social Media Today':
      audienceSlugs.push('smt_marketers');
      break;
  }

  return audienceSlugs;
};

/**
 * @returns {String} The centralized media kit url with relevant utm parameters
 */
const getAdvertiseUrl = () => {
  const params = new URLSearchParams({
    utm_source: siteNameSlug,
    utm_medium: 'button',
    utm_campaign: 'media+kit+button',
  });
  return `https://www.industrydive.com/media-kits?${params.toString()}`;
};

/**
 * Replaces the "Sign up" button with "Advertise"
 */
const replaceSignupWithAdvertise = () => {
  getSignupButtons().forEach((el) => {
    el.href = getAdvertiseUrl();
    el.target = '_blank';
    el.rel = 'noopener noreferrer';
    el.innerText = 'Advertise';
    el.querySelectorAll('img').forEach((img) => img.remove()); // remove icons
    el.classList.remove('t-signup-navigation');
    el.classList.add('t-advertising-navigation');
    el.classList.add('advertise-button');
  });
};

/**
 * This callback decides if the user is a potential marketer for the current site
 * and if so, changes the "Sign up" buttons to "Advertise" buttons, which
 * link to the centralized media kit page.
 *
 * @param profile Lytics profile object that is supplied to the callback via jstag
 */
const lyticsCallback = (profile) => {
  // Array of audiences that indicate a user is a potential marketer of the current site:
  const marketerAudienceSlugs = getMarketerAudienceSlugs();

  // Array of audiences that the current user belongs to:
  const usersAudienceSlugs = profile.data?.user?.segments ?? [];

  // Intersection of the two above array of audiences:
  const usersMarketerAudienceSlugs = usersAudienceSlugs
    .filter((x) => marketerAudienceSlugs.includes(x));

  if (usersMarketerAudienceSlugs.length > 0) {
    // If the current user belongs to an audience that indicates they are a potential
    // marketer of the current site, modify the "Sign up" buttons to be "Advertise" buttons
    replaceSignupWithAdvertise();
  }
  // Otherwise, show the "Sign up" button with the standard URL modification
};

$(document).ready(() => {
  // set signup_path. Done once, outside the try: appending again in the catch duplicated the params
  // whenever Lytics (jstag) wasn't loaded.
  appendSignUpPath();
  try {
    // the signup buttons may be modified by the lyticsCallback
    window.jstag.call('entityReady', lyticsCallback);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
});
